<template>
  <div>
    <modal-box
      :is-active="isModalActive"
      :trash-object-name="trashObjectName"
      @confirm="trashConfirm"
      @cancel="trashCancel"
    />
    <b-table
      :loading="isLoading"
      :paginated="paginated"
      :per-page="perPage"
      :striped="true"
      :hoverable="true"
      default-sort="name"
      :data="announcements"
    >
      <b-table-column label="Nume" field="name" v-slot="props">
        <a
          @click="downloadFile(props.row.uri)"
          class="has-text-underline has-text-dark"
        >
          <span>
            <b-icon icon="file-download" size="is-small" />{{
              props.row.name
            }}</span
          ></a
        >
      </b-table-column>
      <b-table-column
        custom-key="actions"
        cell-class="is-actions-cell"
        v-slot="props"
      >
        <div class="buttons is-right">
          <router-link
            :to="{ name: 'announcement.edit', params: { id: props.row.id } }"
            class="button is-small is-primary"
            title="Editare"
            aria-label="Editare"
          >
            <b-icon icon="file-edit" size="is-small" />
          </router-link>
          <button
            class="button is-small is-danger"
            type="button"
            title="Sterge"
            aria-label="Sterge"
            @click.prevent="trashModal(props.row)"
          >
            <b-icon icon="trash-can" size="is-small" />
          </button>
        </div>
      </b-table-column>
      <section class="section" slot="empty">
        <div class="content has-text-grey has-text-centered">
          <template v-if="isLoading">
            <p>
              <b-icon icon="dots-horizontal" size="is-large" />
            </p>
            <p>Fetching data...</p>
          </template>
          <template v-else>
            <p>
              <b-icon icon="emoticon-sad" size="is-large" />
            </p>
            <p>Nothing's here&hellip;</p>
          </template>
        </div>
      </section>
    </b-table>
  </div>
</template>

<script>
import ModalBox from "@/components/ModalBox";
import { openBlankPage } from "@/helpers/utils";
import { isNilOrEmpty } from "@/helpers/utils";

export default {
  name: "SaleOffersAnnouncementsTable",
  components: { ModalBox },
  props: {
    announcements: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      isModalActive: false,
      trashObject: null,
      clients: [],
      isLoading: false,
      paginated: true,
      perPage: 20,
    };
  },
  computed: {
    trashObjectName() {
      if (this.trashObject) {
        return this.trashObject.name;
      }

      return null;
    },
  },
  mounted() {
    this.isLoading = false;
    if (this.announcements && this.announcements > 0) {
      if (this.announcements.length > this.perPage) {
        this.paginated = true;
      }
    }
  },
  methods: {
    trashModal(trashObject) {
      this.trashObject = trashObject;
      this.isModalActive = true;
    },
    downloadFile(file) {
      if (!isNilOrEmpty(file)) {
        openBlankPage(file);
      }
    },
    trashConfirm() {
      this.isModalActive = false;
      this.$emit("handleDeleteAnnouncement", this.trashObject.id);
      this.$buefy.snackbar.open({
        message: "Inregistrea a fost stearsa.",
        queue: false,
      });
    },
    trashCancel() {
      this.isModalActive = false;
    },
  },
};
</script>
